export default __webpack_public_path__ + "static/tile-variant-do-ad8c1d423cdca453d7e2d0f8358fe39476accf87164eebc74d0eeec0aea7b05b.png";